import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(advancedFormat);
dayjs.extend(localizedFormat);
dayjs.extend(utc);
dayjs.extend(timezone);

const convertDateToUTCString = (date) => {
  return dayjs.utc(dayjs(date).format('YYYY-MM-DDTHH:mm:ss')).format();
};

// Returns a JS Date at 00:00:00 local time for the given input date
const normalizeToStartOfDay = (date) => {
  if (!date) return null;
  return dayjs(date).startOf('day').toDate();
};

// Returns a JS Date at 23:59:59.999 local time for the given input date
const normalizeToEndOfDay = (date) => {
  if (!date) return null;
  return dayjs(date).endOf('day').toDate();
};

const normalizeDate = (date, type) => {
  const convertedDate = new Date(date);
  const year = convertedDate.getFullYear();
  const month = (convertedDate.getMonth() + 1).toString().padStart(2, '0');
  const day = convertedDate.getDate().toString().padStart(2, '0');

  const time = type === 'start' ? '00:00:00' : '23:59:59';

  return new Date(`${year}-${month}-${day} ${time}`);
};

const toLocalOffsetISOString = (date, isEndTime = false) => {
  if (!date) return null;
  const dayjsDate = dayjs(date);
  if (isEndTime) {
    return dayjsDate.endOf('day').format('YYYY-MM-DDTHH:mm:ss');
  }
  return dayjsDate.format('YYYY-MM-DDTHH:mm:ss');
};

export {
  dayjs,
  convertDateToUTCString,
  normalizeToStartOfDay,
  normalizeToEndOfDay,
  normalizeDate,
  toLocalOffsetISOString,
};
